<template>
  <div class="bill-list-circle" style="width: 100%">
    <el-table :data="billList" border style="width: 100%" resizable>
      <el-table-column label="创建时间"   fixed width="100">
        <template slot-scope="scope">
          {{ scope.row.createdTime | moment }}
        </template>
      </el-table-column>
      <el-table-column label="币种" prop="txCoin"  width="120"></el-table-column>
      <el-table-column label="用户Id" prop="userId"  width="140"></el-table-column>
      <el-table-column label="类型"  width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.txType === -1">提现</span>
          <span v-else-if="scope.row.txType === -2">内部地址提现</span>
          <span v-else>充值</span>
        </template>
      </el-table-column>
      <el-table-column label="hash"  width="320">
        <template slot-scope="scope">
          <span>
            <a :href="`${scope.row.hashAddressLink}`" target="_blank">{{
              scope.row.txNetworkId
            }}</a>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="金额" prop="txAmount"  width="120"></el-table-column>
      <el-table-column label="手续费" prop="txFee"  width="120"></el-table-column>
      <el-table-column label="From"  width="280">
        <template slot-scope="scope">
          <span>
            <a :href="`${scope.row.fromAddressLink}`" target="_blank">{{
              scope.row.txFromWallet
            }}</a>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="To"  width="120">
        <template slot-scope="scope">
          <span class="textover">
            <a :href="`${scope.row.toAddressLink}`" target="_blank">{{
              scope.row.txToWalletvv
            }}</a>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="内部状态" prop="txSattusInner"  width="100"  fixed="right"></el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Pagination from 'components/pagination';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState('bill', ['billList', 'pagination', 'totalCount'])
  },
  methods: {
    ...mapMutations('bill', ['setpage']),
    ...mapActions('bill', ['getUserBillList']),
    pageChanged(pagination) {
      this.setpage(pagination);
      this.$emit('refresh', pagination);
    }
  },
  components: {
    Pagination
  }
};
</script>
<style>
/* .textover {
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */
</style>
